import { ReactNode } from 'react';
import { PlusCircleIcon } from '@heroicons/react/solid';

import { EntityHistory } from '../entity-history';
import { DatabaseUser, HistoryItem } from '@/core/types';

export default class FolderCopyHistory extends EntityHistory {
  constructor(history: HistoryItem, user: DatabaseUser) {
    super(history, user);
    this.action = 'copied';
  }

  detailText(): ReactNode {
    if (this.history.attributes?.migrated) {
      return this.history.attributes?.migrated.description;
    } else {
      return (
        <div data-testid="history-detail-text">
          The folder{' '}
          <span className="font-semibold break-all">{this.history.attributes?.prev.name}</span> was
          copied to{' '}
          <span className="font-semibold break-all">{this.history.attributes?.next.name}</span>.
        </div>
      );
    }
  }

  detailIcon(): ReactNode {
    return <PlusCircleIcon className="h-5 fill-support-success" />;
  }
}
